export const dayAfter = (date) => {
  if (!date) return undefined;
  const next = new Date(`${date}T00:00:00Z`);
  if (!Number.isFinite(next.getTime())) return undefined;
  next.setUTCDate(next.getUTCDate() + 1);
  return next.toISOString().slice(0, 10);
};

export const getDepositDateError = ({ depositDate, additionalDepositDate, additionalDeposit, checkInDate }) => {
  if (Number(additionalDeposit) > 0 && additionalDepositDate) {
    if (!depositDate) return 'Vui lòng chọn ngày cọc trước khi chọn ngày cọc bổ sung.';
    if (additionalDepositDate <= depositDate) return 'Ngày cọc bổ sung phải sau ngày cọc, không được trùng ngày cọc.';
  }
  if (depositDate && checkInDate && checkInDate < depositDate) return 'Ngày dự kiến Checkin phải bằng hoặc sau ngày cọc.';
  return '';
};
